import { all, fork } from 'redux-saga/effects'
import botSaga from '../App/sagas'
import trackingSaga from 'hocs/TrackingHOC/saga'

export default function* rootSaga() {
  yield all([
    fork(botSaga),
    fork(trackingSaga)
  ])
}



// WEBPACK FOOTER //
// ./src/store/saga.js